import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Message } from '@solarwindscloud/nighthawk-ui';

export const ErrorMessage = ({ message, renderCloseMessage }) => {
  const [visible, setVisible] = useState(true);

  return (
    visible && (
      <Message error data-test-error-message onDismiss={renderCloseMessage && handleDismissMessage} content={message} />
    )
  );

  function handleDismissMessage() {
    if (renderCloseMessage) {
      setVisible(false);
    }
  }
};

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
  renderCloseMessage: PropTypes.bool,
};

ErrorMessage.displayName = 'ErrorMessage';
